import React from 'react'
import { observer } from 'mobx-react-lite'
import { runInAction } from 'mobx'
import { useParams } from 'react-router-dom';
import axiosService from '../../../../../../utils/AxiosService';
import { toastError } from '../../../../../FormComponents/Toasts';
import CampaignInfluencerComment from './CampaignInfluencerComment';
import CampaignInfluencerCommentsPanel from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerCommentsPanel';


export default observer(function CampaignComments({ auth, isClientThread }) {
  const { campaign_authentication_id } = useParams()

  const handleAddComment = ({ message }, { resetForm }) => {
    axiosService.post(`/api/advertiser/campaign_share/campaign_authentication_client_comments`, { campaign_authentication_id, campaign_authentication_comment: { message } })
      .then((resp) => {
        runInAction(() => {
          auth.client_comments.push(resp)
        })
        resetForm();
      })
      .catch(err => toastError(err))
  }

  return (
    <CampaignInfluencerCommentsPanel
      auth={auth}
      isClientThread={isClientThread}
      onSubmitComment={handleAddComment}
      CommentComponent={CampaignInfluencerComment}
      helperText='Only PMs can see this thread'
    />
  )
})

